import { render, staticRenderFns } from "./pm-price-input.vue?vue&type=template&id=492b3942&"
import script from "./pm-price-input.vue?vue&type=script&lang=js&"
export * from "./pm-price-input.vue?vue&type=script&lang=js&"
import style0 from "./pm-price-input.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports